define('ObjectCollection',['underscore','backbone','prototypes/ObjectPrototype'],function (_,Backbone,ObjectPrototype) {

    //
    // prototype ObjectCollection
    //

    var ObjectCollection = Backbone.Collection.extend({
        backbonePattern:'Collection',
        initialize:function(options){
            var self = this;


            _.each(self.beforeInitialize,function(func,funcName){
                self.executeEachFunction(func,funcName,self);
            });

            self.initAppHttpHeadersChange();

            _.each(self.afterInitialize,function(func,funcName){
                self.executeEachFunction(func,funcName,self);
            });
        }
    }).extend(
        ObjectPrototype
    )

    return ObjectCollection;

});
